// extracted by mini-css-extract-plugin
export default {"contactBox":"Contact_contactBox__akbbc","leftDim":"Contact_leftDim__Lv-oV","rightDim":"Contact_rightDim__Zng8f","deCenter":"Contact_deCenter__wv7KA"};